import {useEffect, useState} from "react";
import DurationInput from "~/components/DurationInput";
import useBusinessPostApi from "~/lib/useBusinessPostApi";
import {useWaitlistSettingsQuery} from "~/lib/Queries";
import {useDebounce} from "@uidotdev/usehooks";
import InfoMessageBlock from "~/components/InfoMessageBlock";

const FIRST_IN_LINE = 'firstinline';

const WaitlistSettings = () => {
    const [notifyOrder, setNotifyOrder] = useState('');
    const [responseTimeframe, setResponseTimeframe] = useState(15)
    const [canSave, setCanSave] = useState(false)

    const {data, isLoading} = useWaitlistSettingsQuery();

    useEffect(() => {
        setNotifyOrder(data?.settings?.notifyOrder || '')
        setResponseTimeframe(parseInt(data?.settings?.responseTimeframe) || 15)
        setCanSave(true)
    }, [JSON.stringify(data?.settings)]);

    const {save, isSaving} = useBusinessPostApi('/waitlist/settings');

    const isFirstInLine = notifyOrder === FIRST_IN_LINE;

    const debouncedResponseTimeframe = useDebounce(responseTimeframe, 500);
    useEffect(() => {
        if (canSave) {
            save({
                notifyOrder,
                responseTimeframe: debouncedResponseTimeframe
            });
        }
    }, [notifyOrder, debouncedResponseTimeframe]);

    return (
        <div className="max-w-2xl">
            <div className="panel-label">How to Notify Clients</div>
            <div className="flex flex-wrap gap-4 items-center mb-6 xs:flex-nowrap">
                <div
                    onClick={() => setNotifyOrder(FIRST_IN_LINE)}
                    className={`cursor-pointer panel p-4 border-2 border-transparent ${isFirstInLine ? '!border-primary-700' : 'text-gray-500'}`}
                >
                    <div>First in Line</div>
                    <div className="text-sm text-gray-500 leading-tight mt-1">
                        Notify the first person on the waitlist when a spot is available.
                        If they don't respond within {responseTimeframe} minutes then move on to the next person.
                    </div>
                </div>

                <div
                    onClick={() => setNotifyOrder('')}
                    className={`cursor-pointer panel p-4 border-2 border-transparent ${!isFirstInLine ? '!border-primary-700' : 'text-gray-500'}`}
                >
                    <div>Notify Everyone</div>
                    <div className="text-sm text-gray-500 leading-tight mt-1">
                        Notify everyone on the waitlist as soon as a slot becomes available, the first person to book it
                        gets the time.
                    </div>
                </div>
            </div>

            {isFirstInLine && (
                <InfoMessageBlock className="mb-4">
                    First in Line notification is not available yet, everyone will be notified when a spot opens.<br />
                    Please <a href="https://support.breely.com/article/4-contact-support" target="_blank">contact us</a> to let us know if you'd like to see first in line notification added.
                </InfoMessageBlock>
            )}

            {isFirstInLine && (
                <div className="max-w-md">
                    <DurationInput
                        value={responseTimeframe}
                        onChange={setResponseTimeframe}
                        label="Response Timeframe"
                        className="max-w-48"
                    />
                    <div className="text-sm text-gray-500 mt-1">
                        If someone doesn't book within this amount of time then the next person in the list will be notified
                    </div>
                </div>
            )}
        </div>
    )
}

export default WaitlistSettings;
